<div
  class="vf-dropdown"
  #vfDropdown
  [ngClass]="variant === 'link' ? 'dropdown-link' : (isWide == true ? 'dropdown-wide' : 'dropdown-simple')"
  data-vf-js-dropdown
  >
  <div class="vf-dropdown__label-container">
    <div
      class="vf-dropdown__label"
      [ngClass]="variant === 'link' ? 'label-link' : (isWide == true ? 'label-wide' : 'label-simple')"
      style="text-align: left"
      >
      {{ label }}
    </div>
    @if (variant === 'link') {
      <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M3.5 6L8 10.5L12.5 6"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          />
      </svg>
    } @else {
      <div [ngClass]="isSvgTop == true ? 'label-simple-pos' : ''">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
          <path
            d="M7 10.5L12 15.5L17 10.5H7Z"
            [attr.fill]="isWide ? 'white' : 'black'"
            />
        </svg>
      </div>
    }

  </div>

  <div
    class="vf-dropdown__menu-container"
    [ngClass]="isWide == true ? 'container-wide' : 'container-simple'"
    >
    <div class="vf-dropdown-overlay"></div>
    <div class="vf-dropdown__menu">
      @for (data of dropdownOptions; track data) {
        <div class="vf-dropdown__menu-item">
          @if (data.isHeader) {
            <div class="vf-dropdown__menu-header">
              {{ data.label }}
            </div>
          }
          @if (data.isShow) {
            <a
              class="vf-dropdown__menu-item-link"
          [ngClass]="{
            'item-disabled': data.disabled,
            'item-wide': isWide,
            'item-simple': !isWide
          }"
          [ngStyle]="
            data.disabled
              ? { color: 'gray', cursor: 'not-allowed', position: 'relative' }
              : {}
          "
              (mouseenter)="data.disabled && (showTooltip = true)"
              (mouseleave)="showTooltip = false"
              (click)="!data.disabled && select(data.value)"
              >
              {{ data.label }}
              <!-- Custom tooltip -->
              @if (data.disabled && showTooltip) {
                <div class="custom-tooltip">
                  {{ data.disabled ? "Please select entries to download" : "" }}
                </div>
              }
            </a>
          }
          <!-- Optional info text below option label -->
          @if (data.info) {
            <div
              class="vf-dropdown__menu-item-info"
          [ngClass]="{
            'item-disabled': data.disabled,
            'item-wide': isWide,
            'item-simple': !isWide
          }"
          [ngStyle]="
            data.disabled
              ? { color: 'gray', cursor: 'not-allowed', position: 'relative' }
              : {}
          "
              (mouseenter)="data.disabled && (showTooltip = true)"
              (mouseleave)="showTooltip = false"
              >
              {{ data.info }}
            </div>
          }
          @if (data.isWarning || data.isDivider) {
            <div>
              <hr class="rule"/>
            </div>
          }
          @if (data.isWarning) {
            <div class="vf-dropdown__menu-warning">
              {{ data.label }}
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
